import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-note-subtitle-list',
  templateUrl: './note-subtitle-list.component.html',
  styleUrls: ['./note-subtitle-list.component.scss']
})
export class NoteSubtitleListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
